import { ICache } from '.';

export default class InMemoryStorageCache implements ICache {
  private storage: Record<string, string> = {};

  clear(): Promise<void> {
    return new Promise(resolve => {
      this.storage = {};
      resolve();
    });
  }

  setItem(path: string, value: any): Promise<void> {
    return new Promise(resolve => {
      this.storage[path] = value;
      resolve();
    });
  }

  getItem(path: string, defaultValue?: any): Promise<Nullable<string>> {
    return new Promise(resolve => {
      let pre = this.storage[path];
      if (!pre) pre = defaultValue;
      resolve(pre);
    });
  }

  removeItem(path: string): Promise<void> {
    return new Promise(resolve => {
      delete this.storage[path];
      resolve();
    });
  }
}
